import React from "react";
import PropTypes from "prop-types";

import IraqTinyMapLoader from "./IraqTinyMapLoader.js";
import USATinyMapLoader from "./USATinyMapLoader.js";
import AfghanistanTinyMapLoader from "./AfghanistanTinyMapLoader.js";
import ChinaTinyMapLoader from "./ChinaTinyMapLoader.js";
import AustraliaTinyMapLoader from "./AustraliaTinyMapLoader.js";

const TinyMapLoader = (props) => {

	switch (props.baseMap) {
		case "United States": {
			return <USATinyMapLoader stateName={props.stateName} actions={props.actions} />
		}
		case "iraq": {
			return <IraqTinyMapLoader stateName={props.stateName} actions={props.actions} />
		}
		case "texas23": {
			return <USATinyMapLoader stateName={props.stateName} actions={props.actions} />
		}
		case "craftsman": {
			return <AfghanistanTinyMapLoader stateName={props.stateName} actions={props.actions} />
		}
		case "australia2022": 
		case "china":
		case "oseAusChina":
		case "koala": {
			switch (props.currentMapId) {
				case "China": {
					return <AustraliaTinyMapLoader actions={props.actions} />;
				}
				default: {
					return <ChinaTinyMapLoader actions={props.actions} />;
				}
			}
		}
		default: {
			return null;
		}
	}

};

TinyMapLoader.propTypes = {
	baseMap: PropTypes.string,
	stateName: PropTypes.string.isRequired,
};

export default TinyMapLoader;
